export default __webpack_public_path__ + "static/media/veg.1a636a33.png";